import { render, staticRenderFns } from "./TypeField.vue?vue&type=template&id=bfc26e36&scoped=true"
import script from "./TypeField.vue?vue&type=script&lang=js"
export * from "./TypeField.vue?vue&type=script&lang=js"
import style0 from "./TypeField.vue?vue&type=style&index=0&id=bfc26e36&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc26e36",
  null
  
)

export default component.exports